export enum MessageStatusEnum {
  COMPLETED = "completed",
  PENDING = "pending",
  ACKNOWLEDGED = "acknowledged",
  POLICE_NOTIFIED = "police notified",
}
